import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { approveRequest } from "../../../axios/Eventlog/EventLogApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const CorfirmApproveRequestDialog = ({
  onClose,
  onRefresh,
  formData,
  onCloseDetail,
  selectedImageId,
  onLoadingChange,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleApproveRequest = async () => {
    setIsSubmitting(true);
    onLoadingChange?.(true);
    try {
      const payload = {
        ...formData,
        langId: localStorage.getItem("i18nextLngId"),
        fileUUID: selectedImageId?.fileUUID ?? null,
        imageEventLogId: selectedImageId?.id ?? null,
      };
      const response = await approveRequest(payload);
      if (response?.data?.responseCode === 0) {
        onClose();
        onCloseDetail?.();
        toast.success(t("common.approve-successfully"));
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsSubmitting(false);
      onLoadingChange?.(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="warning"
      title={t("common.content-171")}
      subtitle={t("common.confirm-approve-request")}
      confirmText={t("button.confirm")}
      loading={isSubmitting}
      onClose={handleCloseDialog}
      onConfirm={handleApproveRequest}
    />
  );
};

export default CorfirmApproveRequestDialog;
